import {WorkspaceBookType, WorkspaceStatuses} from '@shared/core';
import {isCoworking} from '@shared/utilities';
import {TFunction} from 'i18next';

export const getStatusesInWorkspaceSelect = (
  t: TFunction,
  excludeFree: boolean,
  isVirtual: boolean,
  value: WorkspaceBookType,
) => {
  let statuses = [
    {value: WorkspaceStatuses.Free, title: t('statuses.free')},
    {value: WorkspaceStatuses.Booked, title: t('statuses.booked')},
    {value: WorkspaceStatuses.Reserved, title: t('statuses.reserved')},
    {value: WorkspaceStatuses.Occupied, title: t('statuses.occupied')},
    {value: WorkspaceStatuses.CoworkingFree, title: t('statuses.coworkingFree')},
    {value: WorkspaceStatuses.CoworkingBooked, title: t('statuses.coworkingBooked')},
  ];

  if (excludeFree && !isCoworking(value) && !isVirtual) {
    return statuses.filter(
      (status) =>
        status.value !== WorkspaceStatuses.Free &&
        status.value !== WorkspaceStatuses.CoworkingFree &&
        status.value !== WorkspaceStatuses.CoworkingBooked,
    );
  }

  return isVirtual ? [...statuses, {value: WorkspaceStatuses.Remote, title: t('statuses.remote')}] : statuses;
};
